import styled from "styled-components";
import { AppColors } from "./AppColors";

export const App = () => {
  return (
    <StyledMainContainerDiv>
      <StyledSubContainerDiv>
        <StyledMainHeadingDiv>CTNEWS PRIVACY POLICY</StyledMainHeadingDiv>
        <StyledSubHeadingDiv>CTNEWS</StyledSubHeadingDiv>
        <StyledLastUpdatedDiv>
          Last updated: January 20, 2025
        </StyledLastUpdatedDiv>
        <StyledContentDiv>
          <StyledContentDescriptionParagraph>
            We respect the privacy of our users. This Privacy Policy explains
            how we collect, use, disclose, and safeguard your information when
            you visit our mobile application (CTnews). Please read this Privacy
            Policy carefully. IF YOU DO NOT AGREE WITH THE TERMS OF THIS PRIVACY
            POLICY, PLEASE DO NOT ACCESS THE APPLICATION.
          </StyledContentDescriptionParagraph>
          <StyledContentDescriptionParagraph>
            We reserve the right to make changes to this Privacy Policy at any
            time and for any reason. We will alert you about any changes by
            updating the “Last updated” date of this Privacy Policy. You are
            encouraged to periodically review this Privacy Policy to stay
            informed of updates. You will be deemed to have been made aware of,
            will be subject to, and will be deemed to have accepted the changes
            in any revised Privacy Policy by your continued use of the
            Application after the date such revised Privacy Policy is posted.
          </StyledContentDescriptionParagraph>
          <StyledContentDescriptionParagraph>
            This Privacy Policy does not apply to the third-party online/mobile
            store from which you install the Application or make payments,
            including any in-game virtual items, which may also collect and use
            data about you. We are not responsible for any of the data collected
            by any such third party.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            COLLECTION OF YOUR INFORMATION
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            We do not collect any sensitive data from our users. The app is free
            and users don't need to create an account to use it.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            DISCLOSURE OF YOUR INFORMATION
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            We may share information we have collected about you in certain
            situations. Your information may be disclosed as follows:
          </StyledContentDescriptionParagraph>
          <StyledContentSubHeadingDiv>
            By Law or to Protect Rights
          </StyledContentSubHeadingDiv>
          <StyledContentDescriptionParagraph>
            If we believe the release of information about you is necessary to
            respond to legal process, to investigate or remedy potential
            violations of our policies, or to protect the rights, property, and
            safety of others, we may share your information as permitted or
            required by any applicable law, rule, or regulation. This includes
            exchanging information with other entities for fraud protection and
            credit risk reduction.
          </StyledContentDescriptionParagraph>
          <StyledContentSubHeadingDiv>
            Third-Party Service Providers
          </StyledContentSubHeadingDiv>
          <StyledContentDescriptionParagraph>
            We may share your information with third parties that perform
            services for us or on our behalf, including payment processing, data
            analysis, email delivery, hosting services and customer service.
          </StyledContentDescriptionParagraph>
          <StyledContentSubHeadingDiv>
            Sale or Bankruptcy
          </StyledContentSubHeadingDiv>
          <StyledContentDescriptionParagraph>
            If we reorganize or sell all or a portion of our assets, undergo a
            merger, or are acquired by another entity, we may transfer your
            information to the successor entity. If we go out of business or
            enter bankruptcy, your information would be an asset transferred or
            acquired by a third party. You acknowledge that such transfers may
            occur and that the transferee may decline honor commitments we made
            in this Privacy Policy.
          </StyledContentDescriptionParagraph>
          <StyledContentDescriptionParagraph>
            We are not responsible for the actions of third parties with whom
            you share personal or sensitive data, and we have no authority to
            manage or control third-party solicitations. If you no longer wish
            to receive correspondence, emails or other communications from third
            parties, you are responsible for contacting the third party
            directly.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            THIRD-PARTY WEBSITES
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            The Application may contain links to third-party websites and
            applications of interest, including Verified By Visa (VBV)
            authentication, that are not affiliated with us. Once you have used
            these links to leave the Application, any information you provide to
            these third parties is not covered by this Privacy Policy, and we
            cannot guarantee the safety and privacy of your information. Before
            visiting and providing any information to any third-party websites,
            you should inform yourself of the privacy policies and practices (if
            any) of the third party responsible for that website, and should
            take those steps necessary to, at your discretion, protect the
            privacy of your information. We are not responsible for the content
            or privacy and security practices and policies of any third parties,
            including other sites, services or applications that may be linked
            to or from the Application.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            SECURITY OF YOUR INFORMATION
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            We use administrative, technical, and physical security measures to
            help protect your personal information. While we have taken
            reasonable steps to secure the personal information you provide to
            us, please be aware that despite our efforts, no security measures
            are perfect or impenetrable, and no method of data transmission can
            be guaranteed against any interception or other type of misuse. Any
            information disclosed online is vulnerable to interception and
            misuse by unauthorized parties. Therefore, we cannot guarantee
            complete security if you provide personal information.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            POLICY FOR CHILDREN
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            We do not knowingly solicit information from or market to children
            under the age of 13. If you become aware of any data we have
            collected from children under the age of 13, please contact us using
            the contact information provided below.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>
            CONTROLS FOR DO-NOT-TRACK FEATURES
          </StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            Most web browsers and some mobile operating systems include a
            Do-Not-Track (“DNT”) feature or setting you can activate to signal
            your privacy preference not to have data about your online browsing
            activities monitored and collected. No uniform technology standard
            for recognizing and implementing DNT signals has been finalized. As
            such, we do not currently respond to DNT browser signals or any
            other mechanism that automatically communicates your choice not to
            be tracked online. If a standard for online tracking is adopted that
            we must follow in the future, we will inform you about that practice
            in a revised version of this Privacy Policy.
          </StyledContentDescriptionParagraph>
          <StyledContentMainHeadingDiv>CONTACT US</StyledContentMainHeadingDiv>
          <StyledContentDescriptionParagraph>
            If you have questions or comments about this Privacy Policy, please
            contact us at:
          </StyledContentDescriptionParagraph>
          <StyledContentContactDiv>
            <StyledContentDescriptionText>
              CTnews Company Limited
            </StyledContentDescriptionText>
            <StyledContentDescriptionText>Accra</StyledContentDescriptionText>
            <StyledContentDescriptionText>Ghana</StyledContentDescriptionText>
            <StyledContentDescriptionText>
              +233559505063
            </StyledContentDescriptionText>
            <StyledContentDescriptionLink onClick={() => null}>
              clementgyimah2@gmail.com
            </StyledContentDescriptionLink>
          </StyledContentContactDiv>
        </StyledContentDiv>
      </StyledSubContainerDiv>
    </StyledMainContainerDiv>
  );
};

const subContainerDivWidth = 1000;
const subContainerDivMargin = 50;
const mainHeadingDivMarginTop = 50;
const mainHeadingDivFontSize = 30;
const subHeadingDivMarginTop = 30;
const subHeadingDivFontSize = 20;
const lastUpdatedDivMarginTop = 5;
const lastUpdatedDivFontSize = 17;
const contentDivMarginTop = 30;
const contentMainHeadingDivMarginTop = 30;
const contentMainHeadingDivFontSize = 20;
const contentSubHeadingDivMarginTop = 20;
const contentSubHeadingDivFontSize = 17;
const contentDescriptionParagraphFontSize = 17;
const contentDescriptionTextFontSize = 17;
// const contentDescriptionListItemFontSize = 17;
// const contentDescriptionListItemMarginTop = 10;
const contentDescriptionLinkFontSize = 17;
const contentContactDivFontSize = 17;

const StyledMainContainerDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledSubContainerDiv = styled.div`
  width: ${subContainerDivWidth - 500}px;
  margin: ${subContainerDivMargin - 25}px;

  /* extra small screen */
  @media (max-width: 575px) {
    width: ${subContainerDivWidth - 500}px;
    margin: ${subContainerDivMargin - 25}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    width: ${subContainerDivWidth - 400}px;
    margin: ${subContainerDivMargin - 20}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    width: ${subContainerDivWidth - 300}px;
    margin: ${subContainerDivMargin - 15}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    width: ${subContainerDivWidth - 200}px;
    margin: ${subContainerDivMargin - 10}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    width: ${subContainerDivWidth - 100}px;
    margin: ${subContainerDivMargin - 5}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    width: ${subContainerDivWidth}px;
    margin: ${subContainerDivMargin}px;
  }
`;

const StyledMainHeadingDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${mainHeadingDivMarginTop - 25}px;
  font-size: ${mainHeadingDivFontSize - 10}px;
  font-weight: bold;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${mainHeadingDivMarginTop - 25}px;
    font-size: ${mainHeadingDivFontSize - 10}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${mainHeadingDivMarginTop - 20}px;
    font-size: ${mainHeadingDivFontSize - 8}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${mainHeadingDivMarginTop - 15}px;
    font-size: ${mainHeadingDivFontSize - 6}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${mainHeadingDivMarginTop - 10}px;
    font-size: ${mainHeadingDivFontSize - 4}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${mainHeadingDivMarginTop - 5}px;
    font-size: ${mainHeadingDivFontSize - 2}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${mainHeadingDivMarginTop}px;
    font-size: ${mainHeadingDivFontSize}px;
  }
`;

const StyledSubHeadingDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${subHeadingDivMarginTop - 10}px;
  font-size: ${subHeadingDivFontSize - 5}px;
  font-weight: bold;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${subHeadingDivMarginTop - 10}px;
    font-size: ${subHeadingDivFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${subHeadingDivMarginTop - 8}px;
    font-size: ${subHeadingDivFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${subHeadingDivMarginTop - 6}px;
    font-size: ${subHeadingDivFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${subHeadingDivMarginTop - 4}px;
    font-size: ${subHeadingDivFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${subHeadingDivMarginTop - 2}px;
    font-size: ${subHeadingDivFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${subHeadingDivMarginTop}px;
    font-size: ${subHeadingDivFontSize}px;
  }
`;

const StyledLastUpdatedDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: ${lastUpdatedDivMarginTop - 3}px;
  font-size: ${lastUpdatedDivFontSize - 5}px;
  color: ${AppColors.black.blackAlpha050};

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${lastUpdatedDivMarginTop - 3}px;
    font-size: ${lastUpdatedDivFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${lastUpdatedDivMarginTop - 2}px;
    font-size: ${lastUpdatedDivFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${lastUpdatedDivMarginTop - 1}px;
    font-size: ${lastUpdatedDivFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${lastUpdatedDivMarginTop - 1}px;
    font-size: ${lastUpdatedDivFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${lastUpdatedDivMarginTop}px;
    font-size: ${lastUpdatedDivFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${lastUpdatedDivMarginTop}px;
    font-size: ${lastUpdatedDivFontSize}px;
  }
`;

const StyledContentDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: ${contentDivMarginTop - 10}px;

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${contentDivMarginTop - 10}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${contentDivMarginTop - 8}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${contentDivMarginTop - 6}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${contentDivMarginTop - 4}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${contentDivMarginTop - 2}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${contentDivMarginTop}px;
  }
`;

const StyledContentMainHeadingDiv = styled.div`
  margin-top: ${contentMainHeadingDivMarginTop - 10}px;
  font-size: ${contentMainHeadingDivFontSize - 5}px;
  font-weight: bold;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${contentMainHeadingDivMarginTop - 10}px;
    font-size: ${contentMainHeadingDivFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${contentMainHeadingDivMarginTop - 8}px;
    font-size: ${contentMainHeadingDivFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${contentMainHeadingDivMarginTop - 6}px;
    font-size: ${contentMainHeadingDivFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${contentMainHeadingDivMarginTop - 4}px;
    font-size: ${contentMainHeadingDivFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${contentMainHeadingDivMarginTop - 2}px;
    font-size: ${contentMainHeadingDivFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${contentMainHeadingDivMarginTop}px;
    font-size: ${contentMainHeadingDivFontSize}px;
  }
`;

const StyledContentSubHeadingDiv = styled.div`
  margin-top: ${contentSubHeadingDivMarginTop - 10}px;
  font-size: ${contentSubHeadingDivFontSize - 5}px;
  font-weight: bold;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    margin-top: ${contentSubHeadingDivMarginTop - 10}px;
    font-size: ${contentSubHeadingDivFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    margin-top: ${contentSubHeadingDivMarginTop - 8}px;
    font-size: ${contentSubHeadingDivFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    margin-top: ${contentSubHeadingDivMarginTop - 6}px;
    font-size: ${contentSubHeadingDivFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    margin-top: ${contentSubHeadingDivMarginTop - 4}px;
    font-size: ${contentSubHeadingDivFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    margin-top: ${contentSubHeadingDivMarginTop - 2}px;
    font-size: ${contentSubHeadingDivFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    margin-top: ${contentSubHeadingDivMarginTop}px;
    font-size: ${contentSubHeadingDivFontSize}px;
  }
`;

const StyledContentDescriptionParagraph = styled.p`
  font-size: ${contentDescriptionParagraphFontSize - 5}px;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    font-size: ${contentDescriptionParagraphFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    font-size: ${contentDescriptionParagraphFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    font-size: ${contentDescriptionParagraphFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    font-size: ${contentDescriptionParagraphFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    font-size: ${contentDescriptionParagraphFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    font-size: ${contentDescriptionParagraphFontSize}px;
  }
`;

const StyledContentDescriptionText = styled.span`
  font-size: ${contentDescriptionTextFontSize - 5}px;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    font-size: ${contentDescriptionTextFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    font-size: ${contentDescriptionTextFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    font-size: ${contentDescriptionTextFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    font-size: ${contentDescriptionTextFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    font-size: ${contentDescriptionTextFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    font-size: ${contentDescriptionTextFontSize}px;
  }
`;

// const StyledContentDescriptionOrderList = styled.ol``;

// const StyledContentDescriptionUnorderList = styled.ul``;

// const StyledContentDescriptionListItem = styled.li`
//   font-size: ${contentDescriptionListItemFontSize - 5}px;
//   margin-top: ${contentDescriptionListItemMarginTop - 5}px;

//   /* extra small screen */
//   @media (max-width: 575px) {
//     font-size: ${contentDescriptionListItemFontSize - 5}px;
//     margin-top: ${contentDescriptionListItemMarginTop - 5}px;
//   }

//   /* small screen */
//   @media (min-width: 576px) {
//     font-size: ${contentDescriptionListItemFontSize - 4}px;
//     margin-top: ${contentDescriptionListItemMarginTop - 4}px;
//   }

//   /* medium screen */
//   @media (min-width: 768px) {
//     font-size: ${contentDescriptionListItemFontSize - 3}px;
//     margin-top: ${contentDescriptionListItemMarginTop - 3}px;
//   }

//   /* large screen */
//   @media (min-width: 992px) {
//     font-size: ${contentDescriptionListItemFontSize - 2}px;
//     margin-top: ${contentDescriptionListItemMarginTop - 2}px;
//   }

//   /* extra large screen */
//   @media (min-width: 1200px) {
//     font-size: ${contentDescriptionListItemFontSize - 1}px;
//     margin-top: ${contentDescriptionListItemMarginTop - 1}px;
//   }

//   /* extra extra large screen */
//   @media (min-width: 1400px) {
//     font-size: ${contentDescriptionListItemFontSize}px;
//     margin-top: ${contentDescriptionListItemMarginTop}px;
//   }
// `;

const StyledContentDescriptionLink = styled.span`
  font-size: ${contentDescriptionLinkFontSize - 5}px;
  color: ${AppColors.blue.persianBlue};
  cursor: pointer;

  /* extra small screen */
  @media (max-width: 575px) {
    font-size: ${contentDescriptionLinkFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    font-size: ${contentDescriptionLinkFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    font-size: ${contentDescriptionLinkFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    font-size: ${contentDescriptionLinkFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    font-size: ${contentDescriptionLinkFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    font-size: ${contentDescriptionLinkFontSize}px;
  }
`;

const StyledContentContactDiv = styled.div`
  display: flex;
  flex-direction: column;
  font-size: ${contentContactDivFontSize - 5}px;
  color: ${AppColors.black.blackAlpha080};

  /* extra small screen */
  @media (max-width: 575px) {
    font-size: ${contentContactDivFontSize - 5}px;
  }

  /* small screen */
  @media (min-width: 576px) {
    font-size: ${contentContactDivFontSize - 4}px;
  }

  /* medium screen */
  @media (min-width: 768px) {
    font-size: ${contentContactDivFontSize - 3}px;
  }

  /* large screen */
  @media (min-width: 992px) {
    font-size: ${contentContactDivFontSize - 2}px;
  }

  /* extra large screen */
  @media (min-width: 1200px) {
    font-size: ${contentContactDivFontSize - 1}px;
  }

  /* extra extra large screen */
  @media (min-width: 1400px) {
    font-size: ${contentContactDivFontSize}px;
  }
`;
